import { render, staticRenderFns } from "./PlaceAutocomplete.vue?vue&type=template&id=4d5c3e54&scoped=true&"
import script from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PlaceAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./PlaceAutocomplete.vue?vue&type=style&index=0&id=4d5c3e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c3e54",
  null
  
)

export default component.exports